var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_182_66178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 18.3333C12.3015 18.3333 14.3848 17.4006 15.8929 15.8925C17.4009 14.3845 18.3337 12.3012 18.3337 9.99999C18.3337 7.69882 17.4009 5.61549 15.8929 4.10743C14.3848 2.5994 12.3015 1.66666 10.0003 1.66666C7.69916 1.66666 5.61583 2.5994 4.10777 4.10743C2.59973 5.61549 1.66699 7.69882 1.66699 9.99999C1.66699 12.3012 2.59973 14.3845 4.10777 15.8925C5.61583 17.4006 7.69916 18.3333 10.0003 18.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 4.58334C10.575 4.58334 11.0413 5.04972 11.0413 5.62501C11.0413 6.2003 10.575 6.66668 9.99967 6.66668C9.42438 6.66668 8.95801 6.2003 8.95801 5.62501C8.95801 5.04972 9.42438 4.58334 9.99967 4.58334Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2083 14.1667V8.33334H9.79167H9.375",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 14.1667H11.6667",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_182_66178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertOutline);
export default __webpack_public_path__ + "static/media/alert-outline.02d3ef916b9ccafbd422295826628802.svg";
export { ForwardRef as ReactComponent };